// src/components/Chat AI/MarkdownRenderer.js
import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "./MarkdownRenderer.css";

const MarkdownRenderer = ({ content, isStreaming = false }) => {
  return (
    <div className="markdown-content">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          // Custom heading components with proper styling
          h1: ({ children }) => <h1 className="markdown-h1">{children}</h1>,
          h2: ({ children }) => <h2 className="markdown-h2">{children}</h2>,
          h3: ({ children }) => <h3 className="markdown-h3">{children}</h3>,
          h4: ({ children }) => <h4 className="markdown-h4">{children}</h4>,
          h5: ({ children }) => <h5 className="markdown-h5">{children}</h5>,
          h6: ({ children }) => <h6 className="markdown-h6">{children}</h6>,

          // Custom paragraph component
          p: ({ children }) => <p className="markdown-paragraph">{children}</p>,

          // Custom list components
          ul: ({ children }) => <ul className="markdown-ul">{children}</ul>,
          ol: ({ children }) => <ol className="markdown-ol">{children}</ol>,
          li: ({ children }) => <li className="markdown-li">{children}</li>,

          // Custom code components
          code: ({ inline, className, children, ...props }) => {
            return !inline ? (
              <pre className="markdown-code-block">
                <code className={className} {...props}>
                  {children}
                </code>
              </pre>
            ) : (
              <code className="markdown-inline-code" {...props}>
                {children}
              </code>
            );
          },

          // Custom blockquote component
          blockquote: ({ children }) => (
            <blockquote className="markdown-blockquote">{children}</blockquote>
          ),

          // Custom table components
          table: ({ children }) => (
            <div className="markdown-table-wrapper">
              <table className="markdown-table">{children}</table>
            </div>
          ),
          th: ({ children }) => <th className="markdown-th">{children}</th>,
          td: ({ children }) => <td className="markdown-td">{children}</td>,

          // Custom link component
          a: ({ href, children }) => (
            <a
              href={href}
              className="markdown-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {children}
            </a>
          ),

          // Custom strong/bold component
          strong: ({ children }) => (
            <strong className="markdown-strong">{children}</strong>
          ),

          // Custom emphasis/italic component
          em: ({ children }) => <em className="markdown-em">{children}</em>,

          // Custom horizontal rule
          hr: () => <hr className="markdown-hr" />,
        }}
      >
        {content}
      </ReactMarkdown>

      {/* Streaming indicator */}
      {isStreaming && <span className="streaming-indicator">▋</span>}
    </div>
  );
};

export default MarkdownRenderer;